import { Button, Input } from 'antd';
import useConceptWriteAnswer from './useConceptWriteAnswer.hook';
import { StyledConceptWriteAnswer } from './ConceptWriteAnswer.styled';
import { useContext, useRef } from 'react';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';
export default function ConceptWriteAnswer({ concept }) {
  const inputRef = useRef();
  const { state, actions } = useConceptWriteAnswer({ concept, inputRef });
  const game = useContext(GameLoopContext);
  return (
    <StyledConceptWriteAnswer>
      <div className="answer-input">
        <Input
          ref={inputRef}
          value={state.answer}
          onChange={actions.updateAnswer}
          onKeyDown={(e) => {
            e.key == 'Enter' && actions.acceptAnswer();
          }}
          allowClear
          disabled={game.state.givingFeedback}
        />
        <Button
          className="ok-button"
          disabled={game.state.givingFeedback}
          onClick={actions.acceptAnswer}
        >
          Ok
        </Button>
      </div>{' '}
      <div className="spanish-characters">
        <Button
          disabled={game.state.givingFeedback}
          onClick={() => actions.insertCharacter('á')}
        >
          á
        </Button>
        <Button
          disabled={game.state.givingFeedback}
          onClick={() => actions.insertCharacter('é')}
        >
          é
        </Button>
        <Button
          disabled={game.state.givingFeedback}
          onClick={() => actions.insertCharacter('í')}
        >
          í
        </Button>
        <Button
          disabled={game.state.givingFeedback}
          onClick={() => actions.insertCharacter('ó')}
        >
          ó
        </Button>
        <Button
          disabled={game.state.givingFeedback}
          onClick={() => actions.insertCharacter('ú')}
        >
          ú
        </Button>
        <Button
          disabled={game.state.givingFeedback}
          onClick={() => actions.insertCharacter('ü')}
        >
          ü
        </Button>
        <Button
          disabled={game.state.givingFeedback}
          onClick={() => actions.insertCharacter('ñ')}
        >
          ñ
        </Button>
      </div>
    </StyledConceptWriteAnswer>
  );
}
